import {
    BuildingOfficeIcon,
    HeroShieldCheckIcon,
} from '../../Icon'
import {
    Dropdown, DropdownButton, DropdownContent,
} from '../../Dropdown'
import {
    SidebarRealm,
    SidebarRealmsViewProps,
} from './types'
import Button from '../../Button'
import {Icon} from '../../Icon/types'
import LetterAvatar from '../../Avatar/LetterAvatar'
import React from 'react'
import {styled} from 'stitches/config'
import {styledItem} from 'components/Dropdown/styles'
import styles from '../../Dropdown/DropdownButton/styles/DropdownButtonView.module.scss'
import {useTranslation} from 'react-i18next'

const StyledItem = styled('div', styledItem)
const StyledDropdownWrapper = styled('div', {width: '100%'})
const selectedButtonStyles = {
    '& svg': {color: '$buttonTextIconFocus'},
    '[data-id="button-text"]': {color: '$buttonTextContentTextFocus'},
}
const adminModeButtonStyles = {
    '& svg': {color: '$warning'},
    '[data-id="button-text"]': {color: '$warning'},
}
const adminButtonStyles = {
    '& > span': {
        flex: '1 1 0%',
        minWidth: 0,
        textAlign: 'left',
    },
    '& > svg': {marginLeft: '0.6rem'},
    '& svg': {color: '$textIcon'},
    'alignItems': 'center',
    'display': 'flex',
    'justifyContent': 'flex-start',
    'width': '100%',
}

export const getRealmButtonStyles = ({
    admin,
    adminMode,
    selected,
}: Pick<SidebarRealm, 'admin' | 'adminMode'> & {selected: boolean}) => ({
    ...admin ? adminButtonStyles : {},
    ...selected && selectedButtonStyles,
    ...adminMode && adminModeButtonStyles,
})

const SidebarRealmsView = (props: SidebarRealmsViewProps): React.ReactElement => {
    const {
        loadRealm,
        realms,
        selectedRealmId,
        selectedRealmName,
        handleRealmChange,
    } = props

    const {t} = useTranslation()
    const selectedRealm = realms.find(({realm_id}) => realm_id === selectedRealmId)
    const hasAdminMode = realms.some(({adminMode}) => adminMode)

    return (
        <div>
            {realms.length > 0 &&
            <StyledDropdownWrapper>
                <Dropdown>
                    <DropdownButton caret={true} classes={hasAdminMode ? styles.adminMode : ''} customClass='sidebar'>
                        {selectedRealm?.adminMode
                            ? <div><HeroShieldCheckIcon /></div>
                            : <LetterAvatar name={selectedRealmName} size='small' />}
                        <span>{selectedRealmName}</span>
                    </DropdownButton>
                    <DropdownContent customClass='full-width' direction='left'>
                        <StyledItem>
                            <Button
                                color='text'
                                iconLeft={BuildingOfficeIcon}
                                onPress={(): void => { loadRealm(selectedRealmId) }}
                                text={t('Organization dashboard')}
                                type='button'
                            />
                        </StyledItem>
                        <hr />
                        <div>
                            {realms.map(({
                                admin, adminMode, name, realm_id,
                            }: SidebarRealm) => (
                                <StyledItem key={realm_id}>
                                    <Button
                                        avatar={LetterAvatar}
                                        avatarProps={{
                                            name,
                                            size: 'small',
                                        }}
                                        color='text'
                                        css={getRealmButtonStyles({
                                            admin,
                                            adminMode,
                                            selected: selectedRealmId === realm_id,
                                        })}
                                        iconRight={admin ? HeroShieldCheckIcon as unknown as Icon : undefined}
                                        onPress={() => handleRealmChange(realm_id)}
                                        text={name}
                                    />
                                </StyledItem>
                            ))}
                        </div>
                    </DropdownContent>
                </Dropdown>
            </StyledDropdownWrapper>}
        </div>)
}

export default SidebarRealmsView
